import { Typography } from 'omakase';
import React from 'react';

interface FormHeadingProps {
  title?: React.ReactNode;
  subtitle?: string;
  className?: string;
}

const FormHeading: React.FunctionComponent<FormHeadingProps> = ({ title, subtitle, ...rest }) => {
  if (!title && !subtitle) {
    return null;
  }

  const effectiveTitle =
    typeof title === 'string' ? (
      <Typography component="h2" mb={subtitle ? 1.5 : 0} variant="heading04">
        {title}
      </Typography>
    ) : (
      title
    );

  return (
    <div {...rest}>
      {effectiveTitle}
      {subtitle && <Typography variant="body02">{subtitle}</Typography>}
    </div>
  );
};

export default FormHeading;
